<template>
    <CustomizeTemplateImport
        v-if="store.showTemplateCustomization"
        :template-ids="selectedTemplateIds"
        :template-labels="selectedTemplateLabels"
    />

    <TemplatePicker v-else @next="handleNext" />
</template>

<script setup lang="ts">
    import { ref } from "vue";
    import CustomizeTemplateImport from "./CustomizeTemplateImport.vue";
    import TemplatePicker from "./TemplatePicker.vue";
    import { useCategoriesManagerStore } from "./categoriesManagerStore";

    interface SelectedTemplate {
        id: string;
        label: string;
    }

    const store = useCategoriesManagerStore();
    const selectedTemplateIds = ref<string[]>([]);
    const selectedTemplateLabels = ref<string[]>([]);

    function handleNext(templates: SelectedTemplate[]) {
        selectedTemplateIds.value = templates.map(t => t.id);
        selectedTemplateLabels.value = templates.map(t => t.label);
        store.showTemplateCustomization = true;
    }
</script>

<style scoped></style>
